(() => {
  if (customElements.get('ix-home-slideshow')) return;
  class IxHomeSlideshow extends HTMLElement {
    connectedCallback() {
      if (this.connected) return;
      this.connected = true;
      this.slides = [...this.querySelectorAll('[data-slide]')];
      if (this.slides.length < 2) return;
      this.index = 0;
      this.hovered = false;
      this.focused = false;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.motion.matches;
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      this.querySelector('[data-slide-controls]').hidden = false;
      this.querySelector('[data-slide-prev]').addEventListener('click', () => this.show(this.index - 1), options);
      this.querySelector('[data-slide-next]').addEventListener('click', () => this.show(this.index + 1), options);
      this.querySelector('[data-slide-toggle]').addEventListener('click', () => {
        this.paused = !this.paused;
        this.updateToggle();
        this.schedule();
      }, options);
      this.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') { this.hovered = true; this.schedule(); } }, options);
      this.addEventListener('pointerleave', () => { this.hovered = false; this.schedule(); }, options);
      this.addEventListener('focusin', () => { this.focused = true; this.schedule(); }, options);
      this.addEventListener('focusout', event => { if (!this.contains(event.relatedTarget)) { this.focused = false; this.schedule(); } }, options);
      this.addEventListener('keydown', event => {
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          this.show(this.index + (event.key === 'ArrowLeft' ? -1 : 1));
        }
      }, options);
      this.addEventListener('pointerdown', event => { if (event.pointerType === 'touch') this.touchStart = { x: event.clientX, y: event.clientY }; }, options);
      this.addEventListener('pointerup', event => {
        if (!this.touchStart) return;
        const x = event.clientX - this.touchStart.x, y = event.clientY - this.touchStart.y;
        this.touchStart = null;
        if (Math.abs(x) > 50 && Math.abs(x) > Math.abs(y) * 1.5) this.show(this.index + (x < 0 ? 1 : -1));
      }, options);
      this.addEventListener('pointercancel', () => { this.touchStart = null; }, options);
      document.addEventListener('visibilitychange', () => this.schedule(), options);
      this.motion.addEventListener('change', event => { this.paused = event.matches; this.updateToggle(); this.schedule(); }, options);
      document.addEventListener('shopify:block:select', event => {
        const index = this.slides.findIndex(slide => slide.dataset.blockId === event.detail?.blockId);
        if (index >= 0) { this.paused = true; this.updateToggle(); this.show(index); }
      }, options);
      this.observer = new IntersectionObserver(entries => { this.inView = entries[0].isIntersecting; this.schedule(); }, { threshold: 0.2 });
      this.observer.observe(this);
      this.updateToggle();
      this.show(0);
    }
    updateToggle() {
      this.dataset.paused = String(this.paused);
      this.querySelector('[data-slide-toggle]').setAttribute('aria-label', this.paused ? this.dataset.playLabel : this.dataset.pauseLabel);
    }
    show(index) {
      this.index = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, i) => {
        const active = i === this.index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', String(!active));
        slide.inert = !active;
        slide.setAttribute('aria-label', `${i + 1} / ${this.slides.length}`);
      });
      this.querySelector('[data-slide-counter]').textContent = `${this.index + 1} / ${this.slides.length}`;
      this.dataset.activeSlide = String(this.index + 1);
      this.schedule();
    }
    schedule() {
      clearTimeout(this.timer);
      if (this.paused || this.hovered || this.focused || document.hidden || !this.inView) return;
      this.timer = setTimeout(() => this.show(this.index + 1), 5000);
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      this.events?.abort();
      this.observer?.disconnect();
      this.connected = false;
    }
  }
  customElements.define('ix-home-slideshow', IxHomeSlideshow);
})();
